import { render, staticRenderFns } from "./pillar.vue?vue&type=template&id=53fe0963&"
import script from "./pillar.vue?vue&type=script&lang=js&"
export * from "./pillar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports